/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../src/app/app.module';
import * as import2 from '@angular/common';
import * as import3 from '@angular/platform-browser';
import * as import4 from '@angular/platform-browser/animations';
import * as import5 from '@angular/material';
import * as import6 from '@angular/forms';
import * as import7 from '@angular/http';
import * as import8 from '../../../src/app/shared/material.module';
import * as import9 from '../../../src/app/shared/shared.module';
import * as import10 from '../../../src/app/about/about.module';
import * as import11 from '../../../src/app/project/project.module';
import * as import12 from '../../../src/app/contact/contact.module';
import * as import13 from '../../../src/app/core/core.module';
import * as import14 from '../../../src/app/core/contact.service';
import * as import15 from '../../../src/app/core/destroyer.service';
import * as import16 from '../../../src/app/core/project.service';
import * as import17 from '../../../src/app/core/scroll.service';
import * as import18 from '../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import19 from './shared/dialog/dialog.component.ngfactory';
import * as import20 from './app.component.ngfactory';
import * as import21 from '@angular/animations/browser';
class AppModuleInjector extends import0.ɵNgModuleInjector<import1.AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ErrorHandler_1:any;
  _APP_INITIALIZER_2:any[];
  _ApplicationInitStatus_3:import0.ApplicationInitStatus;
  _ɵf_4:import0.ɵf;
  _ApplicationRef_5:any;
  _ApplicationModule_6:import0.ApplicationModule;
  _BrowserModule_7:import3.BrowserModule;
  _BrowserAnimationsModule_8:import4.BrowserAnimationsModule;
  _MdChipsModule_9:import5.MdChipsModule;
  _ɵba_10:import6.ɵba;
  _FormsModule_11:import6.FormsModule;
  _PlatformModule_12:import5.PlatformModule;
  _MdInputModule_13:import5.MdInputModule;
  _PortalModule_14:import5.PortalModule;
  _OverlayModule_15:import5.OverlayModule;
  _CompatibilityModule_16:import5.CompatibilityModule;
  _MdSnackBarModule_17:import5.MdSnackBarModule;
  _A11yModule_18:import5.A11yModule;
  _MdDialogModule_19:import5.MdDialogModule;
  _HttpModule_20:import7.HttpModule;
  _MdIconModule_21:import5.MdIconModule;
  _MdRippleModule_22:import5.MdRippleModule;
  _StyleModule_23:import5.StyleModule;
  _MdButtonModule_24:import5.MdButtonModule;
  _MdCardModule_25:import5.MdCardModule;
  _MdLineModule_26:import5.MdLineModule;
  _MdListModule_27:import5.MdListModule;
  _MdToolbarModule_28:import5.MdToolbarModule;
  _MdProgressBarModule_29:import5.MdProgressBarModule;
  _MdGridListModule_30:import5.MdGridListModule;
  _MdTooltipModule_31:import5.MdTooltipModule;
  _MaterialModule_32:import8.MaterialModule;
  _SharedModule_33:import9.SharedModule;
  _AboutModule_34:import10.AboutModule;
  _ProjectModule_35:import11.ProjectModule;
  _ReactiveFormsModule_36:import6.ReactiveFormsModule;
  _ContactModule_37:import12.ContactModule;
  _CoreModule_38:import13.CoreModule;
  _AppModule_39:import1.AppModule;
  __LOCALE_ID_40:any;
  __NgLocalization_41:import2.NgLocaleLocalization;
  __Compiler_42:import0.Compiler;
  __APP_ID_43:any;
  __IterableDiffers_44:any;
  __KeyValueDiffers_45:any;
  __DomSanitizer_46:import3.ɵe;
  __Sanitizer_47:any;
  __HAMMER_GESTURE_CONFIG_48:import3.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_49:any[];
  __EventManager_50:import3.EventManager;
  __ɵDomSharedStylesHost_51:import3.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_52:import3.ɵDomRendererFactory2;
  __AnimationDriver_53:any;
  __ɵAnimationStyleNormalizer_54:any;
  __ɵAnimationEngine_55:import4.ɵa;
  __RendererFactory2_56:any;
  __ɵSharedStylesHost_57:any;
  __Testability_58:import0.Testability;
  __Meta_59:import3.Meta;
  __Title_60:import3.Title;
  __ɵi_61:import6.ɵi;
  __Platform_62:import5.Platform;
  __OverlayContainer_63:any;
  __ScrollDispatcher_64:any;
  __ɵh_65:any;
  __ɵk_66:import5.ɵk;
  __Overlay_67:import5.Overlay;
  __LiveAnnouncer_68:any;
  __MdSnackBar_69:import5.MdSnackBar;
  __InteractivityChecker_70:import5.InteractivityChecker;
  __FocusTrapFactory_71:import5.FocusTrapFactory;
  __MdDialog_72:import5.MdDialog;
  __BrowserXhr_73:import7.BrowserXhr;
  __ResponseOptions_74:import7.BaseResponseOptions;
  __XSRFStrategy_75:any;
  __XHRBackend_76:import7.XHRBackend;
  __RequestOptions_77:import7.BaseRequestOptions;
  __Http_78:any;
  __MdIconRegistry_79:any;
  __FocusOriginMonitor_80:any;
  __FormBuilder_81:import6.FormBuilder;
  __ContactService_82:import14.ContactService;
  __DestroyerService_83:import15.DestroyerService;
  __ProjectService_84:import16.ProjectService;
  __ScrollService_85:import17.ScrollService;
  constructor(parent:import0.Injector) {
    super(parent,[
      import18.MdSnackBarContainerNgFactory,
      import18.SimpleSnackBarNgFactory,
      import18.MdDialogContainerNgFactory,
      import18.TooltipComponentNgFactory,
      import19.DialogComponentNgFactory,
      import20.AppComponentNgFactory
    ]
    ,[import20.AppComponentNgFactory]);
  }
  get _LOCALE_ID_40():any {
    if ((this.__LOCALE_ID_40 == null)) { (this.__LOCALE_ID_40 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_40;
  }
  get _NgLocalization_41():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_41 == null)) { (this.__NgLocalization_41 = new import2.NgLocaleLocalization(this._LOCALE_ID_40)); }
    return this.__NgLocalization_41;
  }
  get _Compiler_42():import0.Compiler {
    if ((this.__Compiler_42 == null)) { (this.__Compiler_42 = new import0.Compiler()); }
    return this.__Compiler_42;
  }
  get _APP_ID_43():any {
    if ((this.__APP_ID_43 == null)) { (this.__APP_ID_43 = import0.ɵg()); }
    return this.__APP_ID_43;
  }
  get _IterableDiffers_44():any {
    if ((this.__IterableDiffers_44 == null)) { (this.__IterableDiffers_44 = import0.ɵl()); }
    return this.__IterableDiffers_44;
  }
  get _KeyValueDiffers_45():any {
    if ((this.__KeyValueDiffers_45 == null)) { (this.__KeyValueDiffers_45 = import0.ɵm()); }
    return this.__KeyValueDiffers_45;
  }
  get _DomSanitizer_46():import3.ɵe {
    if ((this.__DomSanitizer_46 == null)) { (this.__DomSanitizer_46 = new import3.ɵe(this.parent.get(import3.DOCUMENT))); }
    return this.__DomSanitizer_46;
  }
  get _Sanitizer_47():any {
    if ((this.__Sanitizer_47 == null)) { (this.__Sanitizer_47 = this._DomSanitizer_46); }
    return this.__Sanitizer_47;
  }
  get _HAMMER_GESTURE_CONFIG_48():import3.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_48 == null)) { (this.__HAMMER_GESTURE_CONFIG_48 = new import3.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_48;
  }
  get _EVENT_MANAGER_PLUGINS_49():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_49 == null)) { (this.__EVENT_MANAGER_PLUGINS_49 = [
      new import3.ɵDomEventsPlugin(this.parent.get(import3.DOCUMENT)),
      new import3.ɵKeyEventsPlugin(this.parent.get(import3.DOCUMENT)),
      new import3.ɵHammerGesturesPlugin(this.parent.get(import3.DOCUMENT),this._HAMMER_GESTURE_CONFIG_48)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_49;
  }
  get _EventManager_50():import3.EventManager {
    if ((this.__EventManager_50 == null)) { (this.__EventManager_50 = new import3.EventManager(this._EVENT_MANAGER_PLUGINS_49,this.parent.get(import0.NgZone))); }
    return this.__EventManager_50;
  }
  get _ɵDomSharedStylesHost_51():import3.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_51 == null)) { (this.__ɵDomSharedStylesHost_51 = new import3.ɵDomSharedStylesHost(this.parent.get(import3.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_51;
  }
  get _ɵDomRendererFactory2_52():import3.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_52 == null)) { (this.__ɵDomRendererFactory2_52 = new import3.ɵDomRendererFactory2(this._EventManager_50,this._ɵDomSharedStylesHost_51)); }
    return this.__ɵDomRendererFactory2_52;
  }
  get _AnimationDriver_53():any {
    if ((this.__AnimationDriver_53 == null)) { (this.__AnimationDriver_53 = import4.ɵb()); }
    return this.__AnimationDriver_53;
  }
  get _ɵAnimationStyleNormalizer_54():any {
    if ((this.__ɵAnimationStyleNormalizer_54 == null)) { (this.__ɵAnimationStyleNormalizer_54 = import4.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_54;
  }
  get _ɵAnimationEngine_55():import4.ɵa {
    if ((this.__ɵAnimationEngine_55 == null)) { (this.__ɵAnimationEngine_55 = new import4.ɵa(this._AnimationDriver_53,this._ɵAnimationStyleNormalizer_54)); }
    return this.__ɵAnimationEngine_55;
  }
  get _RendererFactory2_56():any {
    if ((this.__RendererFactory2_56 == null)) { (this.__RendererFactory2_56 = import4.ɵd(this._ɵDomRendererFactory2_52,this._ɵAnimationEngine_55,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_56;
  }
  get _ɵSharedStylesHost_57():any {
    if ((this.__ɵSharedStylesHost_57 == null)) { (this.__ɵSharedStylesHost_57 = this._ɵDomSharedStylesHost_51); }
    return this.__ɵSharedStylesHost_57;
  }
  get _Testability_58():import0.Testability {
    if ((this.__Testability_58 == null)) { (this.__Testability_58 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_58;
  }
  get _Meta_59():import3.Meta {
    if ((this.__Meta_59 == null)) { (this.__Meta_59 = new import3.Meta(this.parent.get(import3.DOCUMENT))); }
    return this.__Meta_59;
  }
  get _Title_60():import3.Title {
    if ((this.__Title_60 == null)) { (this.__Title_60 = new import3.Title(this.parent.get(import3.DOCUMENT))); }
    return this.__Title_60;
  }
  get _ɵi_61():import6.ɵi {
    if ((this.__ɵi_61 == null)) { (this.__ɵi_61 = new import6.ɵi()); }
    return this.__ɵi_61;
  }
  get _Platform_62():import5.Platform {
    if ((this.__Platform_62 == null)) { (this.__Platform_62 = new import5.Platform()); }
    return this.__Platform_62;
  }
  get _OverlayContainer_63():any {
    if ((this.__OverlayContainer_63 == null)) { (this.__OverlayContainer_63 = import5.ɵa(this.parent.get(import5.OverlayContainer,(null as any)))); }
    return this.__OverlayContainer_63;
  }
  get _ScrollDispatcher_64():any {
    if ((this.__ScrollDispatcher_64 == null)) { (this.__ScrollDispatcher_64 = import5.ɵc(this.parent.get(import5.ScrollDispatcher,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__ScrollDispatcher_64;
  }
  get _ɵh_65():any {
    if ((this.__ɵh_65 == null)) { (this.__ɵh_65 = import5.ɵi(this.parent.get(import5.ɵh,(null as any)),this._ScrollDispatcher_64)); }
    return this.__ɵh_65;
  }
  get _ɵk_66():import5.ɵk {
    if ((this.__ɵk_66 == null)) { (this.__ɵk_66 = new import5.ɵk(this._ɵh_65)); }
    return this.__ɵk_66;
  }
  get _Overlay_67():import5.Overlay {
    if ((this.__Overlay_67 == null)) { (this.__Overlay_67 = new import5.Overlay(this._OverlayContainer_63,this.componentFactoryResolver,this._ɵk_66,this._ApplicationRef_5,this,this.parent.get(import0.NgZone))); }
    return this.__Overlay_67;
  }
  get _LiveAnnouncer_68():any {
    if ((this.__LiveAnnouncer_68 == null)) { (this.__LiveAnnouncer_68 = import5.ɵf(this.parent.get(import5.LiveAnnouncer,(null as any)),this.parent.get(import5.LIVE_ANNOUNCER_ELEMENT_TOKEN,(null as any)))); }
    return this.__LiveAnnouncer_68;
  }
  get _MdSnackBar_69():import5.MdSnackBar {
    if ((this.__MdSnackBar_69 == null)) { (this.__MdSnackBar_69 = new import5.MdSnackBar(this._Overlay_67,this._LiveAnnouncer_68,this.parent.get(import5.MdSnackBar,(null as any)))); }
    return this.__MdSnackBar_69;
  }
  get _InteractivityChecker_70():import5.InteractivityChecker {
    if ((this.__InteractivityChecker_70 == null)) { (this.__InteractivityChecker_70 = new import5.InteractivityChecker(this._Platform_62)); }
    return this.__InteractivityChecker_70;
  }
  get _FocusTrapFactory_71():import5.FocusTrapFactory {
    if ((this.__FocusTrapFactory_71 == null)) { (this.__FocusTrapFactory_71 = new import5.FocusTrapFactory(this._InteractivityChecker_70,this.parent.get(import0.NgZone))); }
    return this.__FocusTrapFactory_71;
  }
  get _MdDialog_72():import5.MdDialog {
    if ((this.__MdDialog_72 == null)) { (this.__MdDialog_72 = new import5.MdDialog(this._Overlay_67,this,this.parent.get(import5.MdDialog,(null as any)))); }
    return this.__MdDialog_72;
  }
  get _BrowserXhr_73():import7.BrowserXhr {
    if ((this.__BrowserXhr_73 == null)) { (this.__BrowserXhr_73 = new import7.BrowserXhr()); }
    return this.__BrowserXhr_73;
  }
  get _ResponseOptions_74():import7.BaseResponseOptions {
    if ((this.__ResponseOptions_74 == null)) { (this.__ResponseOptions_74 = new import7.BaseResponseOptions()); }
    return this.__ResponseOptions_74;
  }
  get _XSRFStrategy_75():any {
    if ((this.__XSRFStrategy_75 == null)) { (this.__XSRFStrategy_75 = import7.ɵb()); }
    return this.__XSRFStrategy_75;
  }
  get _XHRBackend_76():import7.XHRBackend {
    if ((this.__XHRBackend_76 == null)) { (this.__XHRBackend_76 = new import7.XHRBackend(this._BrowserXhr_73,this._ResponseOptions_74,this._XSRFStrategy_75)); }
    return this.__XHRBackend_76;
  }
  get _RequestOptions_77():import7.BaseRequestOptions {
    if ((this.__RequestOptions_77 == null)) { (this.__RequestOptions_77 = new import7.BaseRequestOptions()); }
    return this.__RequestOptions_77;
  }
  get _Http_78():any {
    if ((this.__Http_78 == null)) { (this.__Http_78 = import7.ɵc(this._XHRBackend_76,this._RequestOptions_77)); }
    return this.__Http_78;
  }
  get _MdIconRegistry_79():any {
    if ((this.__MdIconRegistry_79 == null)) { (this.__MdIconRegistry_79 = import5.ICON_REGISTRY_PROVIDER_FACTORY(this.parent.get(import5.MdIconRegistry,(null as any)),this._Http_78,this._DomSanitizer_46)); }
    return this.__MdIconRegistry_79;
  }
  get _FocusOriginMonitor_80():any {
    if ((this.__FocusOriginMonitor_80 == null)) { (this.__FocusOriginMonitor_80 = import5.FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(this.parent.get(import5.FocusOriginMonitor,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__FocusOriginMonitor_80;
  }
  get _FormBuilder_81():import6.FormBuilder {
    if ((this.__FormBuilder_81 == null)) { (this.__FormBuilder_81 = new import6.FormBuilder()); }
    return this.__FormBuilder_81;
  }
  get _ContactService_82():import14.ContactService {
    if ((this.__ContactService_82 == null)) { (this.__ContactService_82 = new import14.ContactService(this._Http_78)); }
    return this.__ContactService_82;
  }
  get _DestroyerService_83():import15.DestroyerService {
    if ((this.__DestroyerService_83 == null)) { (this.__DestroyerService_83 = new import15.DestroyerService()); }
    return this.__DestroyerService_83;
  }
  get _ProjectService_84():import16.ProjectService {
    if ((this.__ProjectService_84 == null)) { (this.__ProjectService_84 = new import16.ProjectService()); }
    return this.__ProjectService_84;
  }
  get _ScrollService_85():import17.ScrollService {
    if ((this.__ScrollService_85 == null)) { (this.__ScrollService_85 = new import17.ScrollService()); }
    return this.__ScrollService_85;
  }
  createInternal():import1.AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ErrorHandler_1 = import3.ɵa();
    this._APP_INITIALIZER_2 = [
      import0.ɵo,
      import3.ɵc(this.parent.get(import3.NgProbeToken,(null as any)),this.parent.get(import0.NgProbeToken,(null as any)))
    ]
    ;
    this._ApplicationInitStatus_3 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_2);
    this._ɵf_4 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_1,this.componentFactoryResolver,this._ApplicationInitStatus_3);
    this._ApplicationRef_5 = this._ɵf_4;
    this._ApplicationModule_6 = new import0.ApplicationModule(this._ApplicationRef_5);
    this._BrowserModule_7 = new import3.BrowserModule(this.parent.get(import3.BrowserModule,(null as any)));
    this._BrowserAnimationsModule_8 = new import4.BrowserAnimationsModule();
    this._MdChipsModule_9 = new import5.MdChipsModule();
    this._ɵba_10 = new import6.ɵba();
    this._FormsModule_11 = new import6.FormsModule();
    this._PlatformModule_12 = new import5.PlatformModule();
    this._MdInputModule_13 = new import5.MdInputModule();
    this._PortalModule_14 = new import5.PortalModule();
    this._OverlayModule_15 = new import5.OverlayModule();
    this._CompatibilityModule_16 = new import5.CompatibilityModule(this.parent.get(import3.DOCUMENT,(null as any)));
    this._MdSnackBarModule_17 = new import5.MdSnackBarModule();
    this._A11yModule_18 = new import5.A11yModule();
    this._MdDialogModule_19 = new import5.MdDialogModule();
    this._HttpModule_20 = new import7.HttpModule();
    this._MdIconModule_21 = new import5.MdIconModule();
    this._MdRippleModule_22 = new import5.MdRippleModule();
    this._StyleModule_23 = new import5.StyleModule();
    this._MdButtonModule_24 = new import5.MdButtonModule();
    this._MdCardModule_25 = new import5.MdCardModule();
    this._MdLineModule_26 = new import5.MdLineModule();
    this._MdListModule_27 = new import5.MdListModule();
    this._MdToolbarModule_28 = new import5.MdToolbarModule();
    this._MdProgressBarModule_29 = new import5.MdProgressBarModule();
    this._MdGridListModule_30 = new import5.MdGridListModule();
    this._MdTooltipModule_31 = new import5.MdTooltipModule();
    this._MaterialModule_32 = new import8.MaterialModule();
    this._SharedModule_33 = new import9.SharedModule();
    this._AboutModule_34 = new import10.AboutModule();
    this._ProjectModule_35 = new import11.ProjectModule();
    this._ReactiveFormsModule_36 = new import6.ReactiveFormsModule();
    this._ContactModule_37 = new import12.ContactModule();
    this._CoreModule_38 = new import13.CoreModule();
    this._AppModule_39 = new import1.AppModule();
    return this._AppModule_39;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_1; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_2; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_3; }
    if ((token === import0.ɵf)) { return this._ɵf_4; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_5; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_6; }
    if ((token === import3.BrowserModule)) { return this._BrowserModule_7; }
    if ((token === import4.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_8; }
    if ((token === import5.MdChipsModule)) { return this._MdChipsModule_9; }
    if ((token === import6.ɵba)) { return this._ɵba_10; }
    if ((token === import6.FormsModule)) { return this._FormsModule_11; }
    if ((token === import5.PlatformModule)) { return this._PlatformModule_12; }
    if ((token === import5.MdInputModule)) { return this._MdInputModule_13; }
    if ((token === import5.PortalModule)) { return this._PortalModule_14; }
    if ((token === import5.OverlayModule)) { return this._OverlayModule_15; }
    if ((token === import5.CompatibilityModule)) { return this._CompatibilityModule_16; }
    if ((token === import5.MdSnackBarModule)) { return this._MdSnackBarModule_17; }
    if ((token === import5.A11yModule)) { return this._A11yModule_18; }
    if ((token === import5.MdDialogModule)) { return this._MdDialogModule_19; }
    if ((token === import7.HttpModule)) { return this._HttpModule_20; }
    if ((token === import5.MdIconModule)) { return this._MdIconModule_21; }
    if ((token === import5.MdRippleModule)) { return this._MdRippleModule_22; }
    if ((token === import5.StyleModule)) { return this._StyleModule_23; }
    if ((token === import5.MdButtonModule)) { return this._MdButtonModule_24; }
    if ((token === import5.MdCardModule)) { return this._MdCardModule_25; }
    if ((token === import5.MdLineModule)) { return this._MdLineModule_26; }
    if ((token === import5.MdListModule)) { return this._MdListModule_27; }
    if ((token === import5.MdToolbarModule)) { return this._MdToolbarModule_28; }
    if ((token === import5.MdProgressBarModule)) { return this._MdProgressBarModule_29; }
    if ((token === import5.MdGridListModule)) { return this._MdGridListModule_30; }
    if ((token === import5.MdTooltipModule)) { return this._MdTooltipModule_31; }
    if ((token === import8.MaterialModule)) { return this._MaterialModule_32; }
    if ((token === import9.SharedModule)) { return this._SharedModule_33; }
    if ((token === import10.AboutModule)) { return this._AboutModule_34; }
    if ((token === import11.ProjectModule)) { return this._ProjectModule_35; }
    if ((token === import6.ReactiveFormsModule)) { return this._ReactiveFormsModule_36; }
    if ((token === import12.ContactModule)) { return this._ContactModule_37; }
    if ((token === import13.CoreModule)) { return this._CoreModule_38; }
    if ((token === import1.AppModule)) { return this._AppModule_39; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_40; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_41; }
    if ((token === import0.Compiler)) { return this._Compiler_42; }
    if ((token === import0.APP_ID)) { return this._APP_ID_43; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_44; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_45; }
    if ((token === import3.DomSanitizer)) { return this._DomSanitizer_46; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_47; }
    if ((token === import3.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_48; }
    if ((token === import3.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_49; }
    if ((token === import3.EventManager)) { return this._EventManager_50; }
    if ((token === import3.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_51; }
    if ((token === import3.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_52; }
    if ((token === import21.AnimationDriver)) { return this._AnimationDriver_53; }
    if ((token === import21.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_54; }
    if ((token === import21.ɵAnimationEngine)) { return this._ɵAnimationEngine_55; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_56; }
    if ((token === import3.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_57; }
    if ((token === import0.Testability)) { return this._Testability_58; }
    if ((token === import3.Meta)) { return this._Meta_59; }
    if ((token === import3.Title)) { return this._Title_60; }
    if ((token === import6.ɵi)) { return this._ɵi_61; }
    if ((token === import5.Platform)) { return this._Platform_62; }
    if ((token === import5.OverlayContainer)) { return this._OverlayContainer_63; }
    if ((token === import5.ScrollDispatcher)) { return this._ScrollDispatcher_64; }
    if ((token === import5.ɵh)) { return this._ɵh_65; }
    if ((token === import5.ɵk)) { return this._ɵk_66; }
    if ((token === import5.Overlay)) { return this._Overlay_67; }
    if ((token === import5.LiveAnnouncer)) { return this._LiveAnnouncer_68; }
    if ((token === import5.MdSnackBar)) { return this._MdSnackBar_69; }
    if ((token === import5.InteractivityChecker)) { return this._InteractivityChecker_70; }
    if ((token === import5.FocusTrapFactory)) { return this._FocusTrapFactory_71; }
    if ((token === import5.MdDialog)) { return this._MdDialog_72; }
    if ((token === import7.BrowserXhr)) { return this._BrowserXhr_73; }
    if ((token === import7.ResponseOptions)) { return this._ResponseOptions_74; }
    if ((token === import7.XSRFStrategy)) { return this._XSRFStrategy_75; }
    if ((token === import7.XHRBackend)) { return this._XHRBackend_76; }
    if ((token === import7.RequestOptions)) { return this._RequestOptions_77; }
    if ((token === import7.Http)) { return this._Http_78; }
    if ((token === import5.MdIconRegistry)) { return this._MdIconRegistry_79; }
    if ((token === import5.FocusOriginMonitor)) { return this._FocusOriginMonitor_80; }
    if ((token === import6.FormBuilder)) { return this._FormBuilder_81; }
    if ((token === import14.ContactService)) { return this._ContactService_82; }
    if ((token === import15.DestroyerService)) { return this._DestroyerService_83; }
    if ((token === import16.ProjectService)) { return this._ProjectService_84; }
    if ((token === import17.ScrollService)) { return this._ScrollService_85; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_4.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_51 && this._ɵDomSharedStylesHost_51.ngOnDestroy());
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory<any>(AppModuleInjector,import1.AppModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L3BvcnRmb2xpby9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvcG9ydGZvbGlvL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/app.module.ngfactory.ts